import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";

const TabHeader = ({ description, title }) => (
	<Row className="border-bottom pb-1 mb-4">
		<Col>
			<h2 className="fs-20 fw-bold pt-2 text-neutral3">
				{title}
			</h2>

			<p className="text-secondary">
				{description}
			</p>
		</Col>
	</Row>
);

TabHeader.propTypes = {
	description: PropTypes.string,
	title: PropTypes.string.isRequired
};

TabHeader.defaultProps = {
	description: ""
};

export default TabHeader;
